import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, FormInput, Button } from 'shards-react';
import Spinner from 'react-bootstrap/Spinner';
import Notification from '../components/common/Notification';
import useIsMountedRef from '../hooks/useIsMountedRef';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetPassword } from '../redux/slices/session';
import getErrorMessage from '../utils/getErrorMessage';
import type { ResetPasswordParams } from '../types/session';

const ForgotPassword = (): React.ReactElement => {
  const isMountedRef = useIsMountedRef();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { isLoading } = useSelector((state: RootState) => state.session);
  const [message, setMessage] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const isValidForm: boolean = email.length > 0;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したときのイベントハンドラ
   *
   * @returns {void}
   */
  const dismiss = (): void => {
    setMessage('');
  };

  /**
   * メールアドレス入力時のイベントハンドラ
   *
   * @param {React.MouseEvent<HTMLInputElement>} event - マウスイベントオブジェクト
   * @returns {void}
   */
  const handleChange = (event: React.MouseEvent<HTMLInputElement>): void => {
    setEmail(event.currentTarget.value);
  };

  /**
   * リセットボタンを押したときのイベントハンドラ
   *
   * @param {React.MouseEvent<HTMLInputElement>} event - マウスイベントオブジェクト
   * @returns {void}
   */
  const handleSubmit = async (event: React.MouseEvent<HTMLInputElement>): Promise<void> => {
    event.preventDefault();
    try {
      const params: ResetPasswordParams = {
        email: email,
      }; 
      await dispatch(resetPassword(params)).unwrap();
      history.push({ pathname: '/verify-code', state: { email: email } });
    } catch (err) {
      if (isMountedRef.current) {
        const message: string = getErrorMessage(err);
        setMessage(message);
      }
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Container fluid className="main-content-container h-100 px-4">
        <Row noGutters className="h-100">
          <Col lg="3" md="5" className="auth-form mx-auto my-auto">
            <Card>
              <CardBody>
                <div id="logo">
                  <img className="auth-form__logo d-table mx-auto mb-3" src={`${process.env.PUBLIC_URL}/images/logo_timss_long-3.png`} alt="Mill Sheet Search System - Reset Password" />
                </div>

                <Notification theme={'primary'} isOpen={message.length > 0} message={message} dismissCallback={dismiss} />

                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <label htmlFor="email">{t('user.email')}</label>
                    <FormInput type="email" id="email" placeholder="Email" autoComplete="email" value={email} onChange={handleChange} />
                    <small className="form-text text-muted text-center mt-3">{t('login.reset.message')}</small>
                  </FormGroup>
                  <Button pill theme="accent" className="d-table mx-auto" type="submit" disabled={!isValidForm}>
                    {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />}
                    {t('user.resetPassword')}
                  </Button>
                </Form>
              </CardBody>
            </Card>

            <div className="auth-form__meta d-flex mt-4">
              <Link to="/login" className="mx-auto">
                {t('login.reset.return')}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ForgotPassword;
